import queryString from "query-string"
import { call, put, select } from "redux-saga/effects"

import api from "apis"
import {
  setDeliveryMethods,
  setLoadingShippingMethods,
} from "areas/checkout/store/actions"

export default function* loadDeliveryMethods(action) {
  const state = yield select()

  let orderData = state.checkout.form.initialValues.order
  if (
    [
      "UPDATE_ORDER_VALUES_NOW",
      "UPDATE_ORDER_VALUES",
      "UPDATE_ORDER_DATA",
      "LOAD_DELIVERY_METHODS",
    ].includes(action.type)
  ) {
    orderData = state.checkout.form.values.order
  } else if (action.type === "DEBOUNCE_ORDER_VALUES") {
    orderData = action.props.values.order
  }
  // We don't make this call until the shipping address has a valid postal code to work with
  if (
    state.checkout.order.order.currency !== "EUR" &&
    (!orderData?.ship_address_attributes?.postal_code?.trim() ||
      !!state.checkout.form.errors.order?.ship_address_attributes?.postal_code)
  ) {
    return
  }

  if (!state.checkout.order.delivery.refetch_on_change) {
    return
  }

  yield put(setLoadingShippingMethods(true))

  const query = {
    order_json: JSON.stringify(orderData),
    order_token: state.checkout.order.order.token,
  }
  const result = yield call(
    api.get,
    `/secure/api/v10/checkout/shipping_methods?${queryString.stringify(query)}`
  )
  const data = result?.data

  if (data && data.delivery_json) {
    yield put(setDeliveryMethods(data.delivery_json))

    if (action.setFieldValue && data.delivery_json.current_ship_method) {
      action.setFieldValue(
        "ship_method_id",
        data.delivery_json.current_ship_method
      )
    }
    if (data.address && data.address.verified && action.setFieldValue) {
      // get the state inside of the if to avoid unnecessary getState()
      const currentState = yield select()
      let currentValues = currentState.checkout.form.initialValues
      if (currentState.checkout.form.values.order.ship_address_attributes) {
        currentValues = currentState.checkout.form.values
      }
      // TEMP: to try to eliminate infinite loop
      return

      // Don't update the address if the user has changed the postal code since the delivery methods loaded
      if (
        currentValues.order.ship_address_attributes.postal_code !==
        data.address.postal_code
      ) {
        return
      }
      if (data.address.city) {
        action.setFieldValue(
          "order.ship_address_attributes.city",
          data.address.city
        )
      }
      if (data.address.state) {
        action.setFieldValue(
          "order.ship_address_attributes.state",
          data.address.state
        )
      }
      if (data.address.postal_code) {
        action.setFieldValue(
          "order.ship_address_attributes.postal_code",
          data.address.postal_code
        )
      }
    }
  }
  // Check if Apple/Google Pay Interface waiting for update
  if (window && window.jewlrAppleGooglePay) {
    window.jewlrAppleGooglePay.CallbackController()
  }
}
